import { useCallback } from 'react';
import Text from 'fe-design-base/atoms/Text';
import Link from 'fe-design-base/molecules/Link/Link';

import { toI18n } from 'util/i18n';
import { NAVIGATION } from 'util/navigation';

import Footer from '../components/Footer';
import Header from '../components/Header';
import PastDueDialogBox from '../components/PastDueDialogBox';

import { AfterGracePeriodNonBillingPermissionsViewProps } from './types';

const ctaText = toI18n(
  'past_due_subscription.dialog.non_billing_permission.secondary_cta'
);

export const AfterGracePeriodNonBillingPermissionsView = ({
  closePastDueDialog,
}: AfterGracePeriodNonBillingPermissionsViewProps) => {
  const handleOnClick = useCallback(() => {
    closePastDueDialog();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PastDueDialogBox>
      <Header
        titleI18n="past_due_subscription.dialog.non_billing_permission.after_grace_period.title"
        iconColor="orange300"
        iconName="Warning"
      />
      <Text
        variant="body"
        color="mono900"
        i18n="past_due_subscription.dialog.non_billing_permission.after_grace_period.description"
        asHTML
      />
      <Text variant="bodySm" color="mono900" asHTML>
        {toI18n(
          'past_due_subscription.dialog.non_billing_permission.after_grace_period.contact_information_pre_text'
        )}
        &nbsp;
        <Link href="/help" target="_blank">
          {toI18n(
            'past_due_subscription.dialog.non_billing_permission.after_grace_period.contact_information_link_text'
          )}
        </Link>
        &nbsp;
        {toI18n(
          'past_due_subscription.dialog.non_billing_permission.after_grace_period.contact_information_post_text'
        )}
      </Text>
      <Footer
        secondaryCtaText={ctaText}
        onClickSecondary={handleOnClick}
        secondaryUxElement="sign-out-cta"
        buttonProps={{
          target: '_self',
          dataMethod: 'delete',
          href: NAVIGATION.ACCOUNT_SIGN_OUT,
        }}
      />
    </PastDueDialogBox>
  );
};

export default AfterGracePeriodNonBillingPermissionsView;
